<template>
  <div module-item :class="info.type" v-html="info.value"></div>
</template>

<script>

export default {
  name: 'NumberList',
  props: ['value'],
  computed: {
    info() {
      return this.value;
    },
  },
}
</script>

